export default function* systemIndexSaga() {}
